/**
 * @class
 * @description Wrapper class that injects our modified Theoplayer loader in a Theoplayer instance.
 * @exports Theoplayer
 */
export default class Theoplayer {
    /**
     * Constructs Theoplayer adapter.
     * @param {Object} player Theoplayer player instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(player) {
        new (Theoplayer._adapters.getLoaders().LoaderTheo)(player);
    }
}
